import React, { useState, useEffect } from 'react';

export default function BasicCard(props) {
	// console.log('BasicCard', props);

	return (
		<div className="BasicCard bg-white w-48 rounded-md text-gray-800 text-sm md:text-lg border">
			<title>{props.hellp}</title>
			<body>{props.body}</body>
		</div>
	);
}
